import React from 'react'
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
function About2() {
  return (
    <div style={{ margin: "5px" }}>
      <p style={{ fontSize: "20px"  }}>خانه نقره نیکو</p>
      <div style={{fontSize : "14px"}}>
        <p>خرید و فروش نقره خام (ساچمه) </p>
        <p> مشهد، بازار امام رضا(ع)، بازار اول از سمت فلکه آب، طبقه بالا، پلاک ۶۲/۸۲۱</p>
        <p> <AccessAlarmsIcon /> ساعت کاری :</p>
        <p>- شنبه تا چهارشنبه: ۹:۳۰ صبح الی ۱۹:۳۰</p>
        <p>- پنجشنبه: ۹:۳۰صبح الی ۱۴:۰۰</p>
        <p><PhoneAndroidIcon /> تلفن تماس :</p>
        <p>محسن نیکو: ۰۹۱۵۱۱۱۹۳۲۳  </p>
        <p> مسئول فروش دانیال حسینی: ۰۹۱۵۰۰۱۹۳۲۳</p>
        <p>واحدحسابداری :۰۹۳۰۴۸۸۶۸۰۰</p>
        <a href="http://t.me/newtcbkk_silver_bot">🔍 استعلام قیمت نقره درربات تلگرام</a>
        <br />
        <a href="https://t.me/silverhousenikoo">🔍 لینک کانال اعلام قیمت</a>
        <br />
        <a href={`tel:#88099*6655*}#`}>📲 کد دستوری</a>
        <p>✅مظنه خرید فروش ساعت ۱۱:۳۰ الی ۱۲ هر روزکاری اعلام مشخص و اعلام میگردد</p>
      </div>


    </div>
  )
}

export default About2